import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import "./EmailChip.css";

const EmailChip = (props: any) => {
  
  const [state, setState] = useState({
    items:  [],
    value: "",
    error: null
  });

  const handleKeyDown = (evt) => {
    if (["Enter", "Tab", ","].includes(evt.key)) {
      evt.preventDefault();

      console.log(state);

      const value = state.value.trim().toLowerCase();

      if (value && isValid(value)) {
        setState({ ...state, items: [...state.items, state.value.trim().toLowerCase()], value: "" });
        props.setState({ ...state, items: [...state.items, state.value.trim().toLowerCase()], value: "" });
      }
    }
  };

  const handleChange = (evt) => {
    setState({ ...state, value: evt.target.value, error: null });
  };

  const handleDelete = (item) => {
    setState({ ...state, items: state.items.filter((i) => i !== item) });
    props.setState({ ...state, items: state.items.filter((i) => i !== item) });
  };

  // const handlePaste = (evt: any) => {
  //   evt.preventDefault();

  //   const paste = evt.clipboardData.getData("text");
  //   const emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

  //   if (emails) {
  //     const toBeAdded = emails.filter((email) => !isInList(email));

  //     setState({ ...state, items: [...state.items, ...toBeAdded] });
  //     props.setState({ ...state, items: [...state.items, ...toBeAdded] });
      
  //   }
  // };

  const isValid = (email: string) => {
    let error = null;

    if (isInList(email)) {
      error = `${email} já adicionado.`;
    }

    if (!isEmail(email)) {
      error = `${email} não é um e-mail válido.`;
    }

    if (error) {
      setState({ ...state, error });
      return false;
    }

    return true;
  };

  const isInList = (email: string) => {
    return state.items.includes(email);
  };

  const isEmail = (email: string) => {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  };
  
  useEffect(() => {
    if (props.emails){
      setState({
        items: props.emails.items || [],
        value: "",
        error: null
      });      
    }
  }, [props?.emails]);

  return (
    <>
      <input
        className={"input " + (state.error && " has-error") + " " + props.class}
        value={state.value}
        placeholder="Digite ou cole e-mails aqui e pressione 'Enter'..."
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        // onPaste={handlePaste}
      />
      {state.error && <p className="error">{state.error}</p>}
      {state.items.map((item) => (
        <div className="tag-item" key={item}>
          {item}
          <button
            type="button"
            className="button"
            onClick={() => handleDelete(item)}
          >
            &times;
          </button>
        </div>
      ))}
    </>
  );
};

export default EmailChip;
